import * as React from 'react';
import * as FileSaver from 'file-saver';
import { Workbook } from 'exceljs';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import imageSat from '../../../shared-components/satImage';
import imageBest from '../../../shared-components/imageBest';

const ExportCSVChart = ({ fileName, data}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  

  const exportToExcel = (file, data, keys) => {
    const fileExtension = '.xlsx';
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Portada', { views: [{ showGridLines: false }] });
    const worksheet2 = workbook.addWorksheet('Bestel Telecomunicaciones');

    worksheet.mergeCells('A8:Q28');

    worksheet.getCell('A8').fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: '0B610B' },
    };

    worksheet.getCell('A8:Q28').value = {
      richText: [
        {
          font: {
            bold: true,
            size: 35,
            color: { argb: 'ffffff' },
            name: 'Calibri',
            family: 2,
            scheme: 'minor',
          },
          text: file,
        },
      ],
    };

    worksheet.getCell('A8').alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    };


    const image1 = workbook.addImage({
      base64: imageSat,
      extension: 'png',
    });
    const image2 = workbook.addImage({
      base64: imageBest,
      extension: 'png',
    });

    worksheet.addImage(image1, {
      tl: { col: 2, row: 1 },
      ext: { width: 650, height: 100 },
    });

    worksheet2.mergeCells('C1:E5')

    worksheet2.getCell('C1:E5').value = {
      richText: [
        {
          font: {
            bold: true,
            size: 16,
            color: { argb: '000000' },
            name: 'Calibri',
            family: 2,
            scheme: 'minor',
          },
          text: file,
        }
      ],
    };

    worksheet2.getCell('C1').alignment = {
      vertical: 'middle',
      horizontal: 'center',
      wrapText: true,
    }

    worksheet2.addImage(image2, {
      tl: { col: 1, row: 0 },
      ext: { width: 300, height: 100 },
    });

    worksheet2.addImage(image1, {
      tl: { col: 5, row: 1 },
      ext: { width: 350, height: 80 },
    });


    worksheet2.addRow();
    worksheet2.addRow();
    let indexFin = 0;

    const letras = [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ];

    // eslint-disable-next-line func-names
    keys.forEach(function (item, index) {
      let head = '';
      const partes = item.split(/(?=[A-Z])/);
      partes.forEach((part) => {
        head = `${head}  ${part.toUpperCase()}`;
      });
      indexFin = `${letras[index].toUpperCase()}7`;
      worksheet2.getCell(indexFin).border = {
        top: { style: 'medium', color: { argb: '000000' } },
        left: { style: 'medium', color: { argb: '000000' } },
        bottom: { style: 'medium', color: { argb: '000000' } },
        right: { style: 'medium', color: { argb: '000000' } },
      };
      worksheet2.getCell(indexFin).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0B610B' },
      };
      worksheet2.getCell(indexFin).value = {
        richText: [
          {
            font: {
              bold: false,
              size: 14,
              color: { argb: 'ffffff' },
              name: 'Calibri',
              family: 2,
              scheme: 'minor',
            },
            text: head,
          },
        ],
      };
    });

    // eslint-disable-next-line func-names
    data.forEach(function (item, index) {
      const row = Object.values(item);
      worksheet2.addRow(row);
    });

    worksheet2.columns = [
      { width: 15 },
      { width: 37 },
      { width: 20 },
      { width: 20 },
      { width: 50 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 35 },
      { width: 35 },
    ];

    let rowIndex = 1;
    // eslint-disable-next-line no-plusplus
    for (rowIndex; rowIndex <= worksheet2.rowCount; rowIndex++) {
      worksheet2.getRow(rowIndex).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    }

    setIsLoading(false)
    // eslint-disable-next-line func-names
    workbook.xlsx.writeBuffer().then(function (buffer) {
      const blob = new Blob([buffer], { type: 'application/xlsx' });
      FileSaver(blob, file + fileExtension);
    });
  }

  const handleButtonClick = async () => {
    setIsLoading(true);
    const object1 = data[0];
    const keys = Object.keys(object1);
    exportToExcel(fileName, data, keys);
  };

  return (
    <>
      {isLoading && <CircularProgress size={30} sx={{ color: 'white' }} />}
      {!isLoading && (
        <IconButton aria-label="delete" onClick={handleButtonClick}>
          <VerticalAlignBottomIcon />
        </IconButton>
      )}
    </>
  );
};

export default ExportCSVChart;